import { STR } from "../i18n.js";
import { useStore } from "../store.js";
import { Field, NumberField, Panel } from "./ui-primitives.js";

export function Settings() {
  const {
    descentRate,
    ascentRate,
    lastStopDepth,
    stopIncrement,
    lang,
    setRates,
    setStops,
  } = useStore();
  const t = STR[lang];

  return (
    <Panel title={t.settings}>
      <div className="field-row">
        <Field label={t.descent}>
          <NumberField
            value={descentRate}
            min={5}
            max={30}
            step={1}
            suffix="m/min"
            onChange={(v) => setRates(ascentRate, v)}
          />
        </Field>
        <Field label={t.ascent}>
          <NumberField
            value={ascentRate}
            min={3}
            max={18}
            step={1}
            suffix="m/min"
            onChange={(v) => setRates(v, descentRate)}
          />
        </Field>
      </div>
      <div style={{ height: 8 }} />
      <div className="field-row">
        <Field label={t.last_stop}>
          <NumberField
            value={lastStopDepth}
            min={3}
            max={6}
            step={1}
            suffix="m"
            onChange={(v) => setStops(v, stopIncrement)}
          />
        </Field>
        <Field label={lang === "fr" ? "Espacement" : "Stop step"}>
          <NumberField
            value={stopIncrement}
            min={3}
            max={6}
            step={1}
            suffix="m"
            onChange={(v) => setStops(lastStopDepth, v)}
          />
        </Field>
      </div>
    </Panel>
  );
}
